"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
/**
 * Dummy implementation of provider's interface for basic usage.
 * Supports two languages: English and Bengali for demonstration purposes.
 *
 * @class
 * @implements CurrentLanguageProvider
 */
var DemoCurrentLanguageProvider = /** @class */ (function () {
    /**
     * @constructs
     */
    function DemoCurrentLanguageProvider() {
        var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        var multilingualEnglishName = multilingualStringBuilder
            .withValueForLanguage(7, 'english')
            .withValueForLanguage(8, '[bgd]english')
            .build();
        var multilingualEnglishAcronym = multilingualStringBuilder
            .withValueForLanguage(7, 'eng')
            .withValueForLanguage(8, '[bgd]eng')
            .build();
        var multilingualBengaliName = multilingualStringBuilder
            .withValueForLanguage(7, 'bengali')
            .withValueForLanguage(8, '[bgd]bengali')
            .build();
        var multilingualBengaliAcronym = multilingualStringBuilder
            .withValueForLanguage(7, 'bng')
            .withValueForLanguage(8, '[bgd]bng')
            .build();
        this.english = new idm_crosscutting_concepts_frontend_1.Language(7, multilingualEnglishName, multilingualEnglishAcronym, idm_crosscutting_concepts_frontend_1.LanguageDirection.LTR);
        this.bengali = new idm_crosscutting_concepts_frontend_1.Language(8, multilingualBengaliName, multilingualBengaliAcronym, idm_crosscutting_concepts_frontend_1.LanguageDirection.LTR);
        this.language = new BehaviorSubject_1.BehaviorSubject(this.english);
    }
    /**
     * @inheritDoc
     */
    DemoCurrentLanguageProvider.prototype.getCurrentLanguage = function () {
        return this.language;
    };
    /**
     * Switch current language to Bengali.
     */
    DemoCurrentLanguageProvider.prototype.setCurrentLanguageBengali = function () {
        this.language.next(this.bengali);
    };
    /**
     * Switch current language to English.
     */
    DemoCurrentLanguageProvider.prototype.setCurrentLanguageEnglish = function () {
        this.language.next(this.english);
    };
    return DemoCurrentLanguageProvider;
}());
exports.DemoCurrentLanguageProvider = DemoCurrentLanguageProvider;
//# sourceMappingURL=demo-current-language-provider.service.js.map